import { createFileRoute } from "@tanstack/react-router";
import { redirect } from "../../../../../scaffolding/router-api";

export const Route = createFileRoute("/_auth/_organisation/organisation/exports/")({
  beforeLoad: () => {
    throw redirect({ to: "/organisation/exports/price-breakdown-coefficients", replace: true });
  },
});
